<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="16px"
      viewBox="0 0 13.503 23.619"
    >
      <path
        id="Icon_ionic-ios-arrow-back"
        data-name="Icon ionic-ios-arrow-back"
        d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z"
        transform="translate(-11.251 -6.194)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  setup() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
